import {$authHost, $host} from "./index";
import {catalogItemId} from "../util/catalogItemId";
import {ITEMS_ALL, ITEMS_ID} from "./ApiEndpoints";

export const fetchDataUnauth = async (url) => {
    const {data} = await $host.get(url)
    return data
}

/**
 * Список товаров с пагинацией (ответ: { items, currentPage, pageSize, totalElements, totalPages, first, last }).
 * Параметры: page, size, sort; query (фрагмент названия); category; minPrice, maxPrice, minCount;
 * maxStock (например 0 — нет в наличии); onlyAvailable; filtered (false в админке — показать нулевой остаток).
 */
export const fetchItemsPage = async (params = {}) => {
    const clean = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
    )
    const {data} = await $host.get(ITEMS_ALL, {params: clean})
    return data
}

const appendItemJsonAndFiles = (formData, itemFields, files) => {
    formData.append('itemRequest', new Blob([JSON.stringify(itemFields)], {type: 'application/json'}))
    const list = Array.isArray(files) ? files : []
    for (let i = 0; i < list.length; i++) {
        if (list[i]) {
            formData.append('files', list[i])
        }
    }
}

export const createItem = async (item, files) => {
    const {id: _id, retainImageFilenames: _r, ...fields} = item
    const formData = new FormData()
    appendItemJsonAndFiles(formData, fields, files)
    const {data} = await $authHost.post(ITEMS_ALL, formData)
    return data
}

/**
 * @param {object} item — поля товара (в т.ч. id для URL)
 * @param {File[]} files — только новые файлы
 * @param {string[]} retainImageFilenames — какие существующие filename оставить
 */
export const updateItem = async (item, files, retainImageFilenames) => {
    const {id: _id, ...rest} = item
    const jsonPayload = {
        title: rest.title,
        description: rest.description,
        price: rest.price,
        count: rest.count,
        category: rest.category,
        retainImageFilenames: retainImageFilenames ?? [],
    }
    const formData = new FormData()
    appendItemJsonAndFiles(formData, jsonPayload, files)
    const {data} = await $authHost.put(ITEMS_ID + catalogItemId(item), formData)
    return data
}

export const fetchItemById = async (id) => {
    if (id == null || id === 'undefined' || String(id).trim() === '' || !Number.isFinite(Number(id))) {
        return Promise.reject(new Error('Invalid item id'))
    }
    const {data} = await $host.get(ITEMS_ID + id)
    return data
}
